import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { ThemePipe } from '../../../../core/pipes/theme.pipe';

// The surfaces that stage tokens for the box, so a prefix without them is a type error at the
// call site rather than an unstyled box. The drawer's tokens alias the card's.
export type SoloStatTokens = 'card-solo-stat' | 'drawer-solo-stat';

// One of the Outscore boxes: a label over a figure the caller projects (a target with its "pts",
// or a currency amount), on the paid card's progress-track tint. The card, the Solo sheet and the
// new-target drawer all draw their boxes with it, so the sheet repeats exactly what the player
// tapped. The figure's own type and colour stay the caller's.
@Component({
  selector: 'app-solo-stat',
  templateUrl: './solo-stat.component.html',
  styleUrls: ['./solo-stat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, ThemePipe],
})
export class SoloStatComponent {
  readonly label = input.required<string>();
  readonly tokens = input.required<SoloStatTokens>();

  readonly boxStyles = computed((): [string, string][] => [
    ['background', this.tokens()],
    ['border-radius', this.tokens()],
  ]);
  readonly labelStyles = computed((): [string, string][] => [
    ['type', `${this.tokens()}-label`],
    ['text-color', `${this.tokens()}-label`],
  ]);
}
